import {useOwnProfile} from "../../../stores/OwnProfileStore.ts";
import {Region} from "../../../types/domain.ts";
import {isRegionManager, isStaff} from "../../../utils/userTypeGuards.ts";

export const useUserRegion = (): [number | null, Region[] | null] => {
    const { profile } = useOwnProfile();
    if(!profile) return [null, null];
    if(isStaff(profile)) return [null, null];
    if(isRegionManager(profile)) return [profile.region.id, null];

    const allSameRegion = profile.firs.every(f => f.region.id === profile.firs[0].region.id);
    if(allSameRegion) return [profile.firs[0].region.id, null];

    return [null, Array.from(
        new Map(profile.firs.map(f => [f.region.id, f.region])).values()
    )]
}